import styles from './PageFooter.module.scss';
import {RoutePaths} from '../../../router/RoutePaths';
import {AppTheme, rbswLogo, rbswLogoGreen} from '../../../appTheme';
import React, {CSSProperties, memo} from 'react';
import {Row} from 'react-bootstrap';


type Props = {style?: CSSProperties; green?: boolean};


export const PageFooter = memo(({style, green = false}: Props) => {
  const footerTextColor = green ? {color: AppTheme.colors.themeGreen} : {};
  return (
    <Row className={styles['footer']} style={style}>
      <div className={styles['footer-text']} style={{...footerTextColor}}>
        Created by RavenBridge Software LLC
      </div>
      <a href={RoutePaths.rbswLink} style={{display: 'flex', maxWidth: '4%', minWidth: '4rem'}} target={'_blank'}>
        <img src={green ? rbswLogoGreen() : rbswLogo()} alt='RavenBridge Software Logo' className={styles['logo']}/>
      </a>
    </Row>
  );
});
